import { notification } from 'antd';
import { useTranslationWithNamespace } from './useTranslationWithNamespace';

/**
 * Hook for displaying notifications
 * @returns Object with functions to show different types of notifications
 */
export const useNotification = () => {
  const { t } = useTranslationWithNamespace('common');

  /**
   * Show a success notification
   * @param message Success message title
   * @param description Optional description
   */
  const showSuccessNotification = (message: string, description?: string) => {
    notification.success({
      message,
      description,
      placement: 'topRight',
      duration: 4,
    });
  };

  /**
   * Show an error notification
   * @param message Error message title
   * @param description Optional description
   */
  const showErrorNotification = (message: string, description?: string) => {
    notification.error({
      message,
      description,
      placement: 'topRight',
      duration: 6,
    });
  };

  /**
   * Show a warning notification
   * @param message Warning message title
   * @param description Optional description
   */
  const showWarningNotification = (message: string, description?: string) => {
    notification.warning({
      message,
      description,
      placement: 'topRight',
      duration: 5,
    });
  };

  /**
   * Show an info notification
   * @param message Info message title
   * @param description Optional description
   */
  const showInfoNotification = (message: string, description?: string) => {
    notification.info({
      message,
      description,
      placement: 'topRight',
      duration: 4,
    });
  };

  return {
    showSuccessNotification,
    showErrorNotification,
    showWarningNotification,
    showInfoNotification,
  };
};
